import { renderToStaticMarkup } from 'react-dom/server';

import { HooksService } from 'basic-components';
import { LakeIcon } from 'basic-components/icons'; // <-- use the real path/export

const registerLakeIcon = editor => {
  const svg = renderToStaticMarkup(
    <LakeIcon 
        height={20}
        width={20} 
      />
  )

  editor.ui.registry.addIcon('lake', svg);
}

/* eslint-disable camelcase */

export const getToolbar = () => "undo redo | blocks fontfamily fontsize | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | pagebreak |"

export const htmlConfig = {
  allow_unsafe_link_target: true, // allow links to external sources
  apply_source_formatting: true, // do not remove fotmatting
  branding: false, // remove logo
  content_css: '/HtmlEditor.css', // css for fonts
  font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago;  Montserrat=montserrat; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; Roboto=roboto,arial,sans-serif;", // avaible fonts
  font_size_formats: "8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 20px 22px 24px 26px 28px",
  fullpage_hide_in_source_view: false, // show title and header
  height: "100%", // height of editor
  menu: {
    file: { title: 'File', items: 'newdocument | preview | print | datalakePicker' },
    edit: { title: 'Edit', items: 'undo redo | cut copy paste | selectall | searchreplace' },
    view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | fullscreen' },
    insert: { title: 'Insert', items: 'image link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime' },
    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | removeformat' },
    tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | code wordcount' },
    table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' }
  },
  promotion: false, // remove button for buying premium license
  pagebreak_split_block: true, // improve pagebreak
  paste_data_images: true,
  preformatted : true, // again keep some source formatting
  resize: false, // do not allow editor resize
  skin: 'oxide', // !important. Has to be included and parsed in index.js. Default skin
  selector: 'textarea', // element behind editor
  width: "100%", // width of editor,
}

export const plugins = [
  'advlist', 'anchor', 'autolink', 'code', 'help', 'image', 'link', 'lists',
  'searchreplace', 'table', 'wordcount', 'visualblocks', 'media', 'pagebreak', 'charmap',
  'insertdatetime', 'datalakePicker', 'preview', 'fullscreen'
]

export const usePngSelectorAction = (getFileLocationCall, s3GetCall, setPngSelectorIsOpen, setSubmitPngSelector, tinymce) => 
  HooksService.useComponentWillMount(() => tinymce.PluginManager.add('datalakePicker', function (editor) {
    registerLakeIcon(editor);

    editor.ui.registry.addMenuItem('datalakePicker', {
      id: "datalakePicker",
      icon: "lake",
      text: 'Add image from Data lake',
      onAction: () => {
        setPngSelectorIsOpen(true)
        setSubmitPngSelector(() => file => {
          getFileLocationCall({ id: file.id })
            .then(response => response.headers.get("Location"))
            .then(location => 
              s3GetCall({ url: location })
                .then(response => response.blob())
                .then(response => {
                  new Promise(resolve => {
                      const reader = new FileReader();
                      reader.onload = () => resolve(reader.result);
                      reader.readAsDataURL(response); 
                    }).then(dataUrl => {
                      const localDataUrl = "data:image/png;" + dataUrl.split(";")[1]
                      editor.selection.setContent(`<img src="${localDataUrl}"/>`)
                    });
                })
            )
        })
      }
    });
  }))